import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {MainService} from './main.service';
import {DatePipe} from '@angular/common';

@Injectable()
export class CommandService {

    constructor(public http: Http, public mainService: MainService, private datePipe: DatePipe) {
    }

    findAll() {
        return new Promise((resolve, reject) => {
            this.http.get(this.mainService.server_url + 'command')
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
    }

    findCommand(idUser: String, idDevice: String, startDate: Date, endDate: Date) {
        const request = {
            idUser: idUser,
            startDate: this.datePipe.transform(startDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            endDate: this.datePipe.transform(endDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice
        };
        return new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'command/findCommand', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
    }

    create(command: any) {
        return new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'command', command)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
    }

    edit(command: any) {
        return new Promise((resolve, reject) => {
            this.http.put(this.mainService.server_url + 'command/id;idDevice=' + command.idDevice + ';idCommand='
                + command.idCommand, command)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
    }

    remove(idDevice: String, idCommand: number) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.mainService.server_url + 'command/id;idDevice=' + idDevice + ';idCommand=' + idCommand)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/command.service.ts